import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Divider, Space } from "antd";

import { Header, Nav, HamburgerMenu, BtnEdit, BaseTable } from "./components";

import {
  loginUserCheck,
  logoutUser,
  brandFetch,
  brandDeleteById,
  brandFetchPromo,
} from "../redux/actions";

class AdminProduct extends Component {
  constructor() {
    super();
    this.state = {
      photo: "",
      promoImg: "",
      isEdit: false,
      toggleMenu: false,
      columns: [
        {
          title: "Image",
          dataIndex: "img",
          key: "img",
          render: (text) => (
            <div style={{ textAlign: "left" }}>
              <img
                src={text}
                style={{ height: "30px", maxWidth: "100px" }}
                alt="product"
              />
            </div>
          ),
        },
        {
          title: "Brand",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "Created Date",
          dataIndex: "brand_id",
          key: "brand_id",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                  window.location = `/admin/productdetail?id=${record.id}&title=${record.title}`;
                }}
              >
                ดูสินค้า
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                  const search = `?id=${record.id}&title=${record.title}&img=${record.img}&order=${record.order}`;
                  window.location = `/admin/editbrand${search}`;
                }}
              >
                แก้ไข
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                danger
                onClick={() => this._onDeleteItem(record.id, record.img)}
              >
                ลบ
              </Button>
            </Space>
          ),
        },
      ],
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    this.props.brandFetch();
    this.props.brandFetchPromo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.promoImg) {
      this.setState({ promoImg: nextProps.promoImg });
    }
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _onDeleteItem(id, img) {
    if (window.confirm("Are you sure you want to delete this item?")) {
      let oldImg = decodeURIComponent(img.substring(70, 95));
      this.props.brandDeleteById(id, oldImg);
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-product">
          <Nav active="product" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>สินค้า : ยี่ห้อ</h2>
                <div className="btn-addbrand">
                  <Link to="/admin/addbrand" className="add-brand">
                    เพิ่มยี่ห้อ
                  </Link>
                </div>
              </div>
              <div className="banner">
                <form action="" className="photo">
                  <div className="banner-title">
                    <p>Promotion Banner (414x173px)</p>
                  </div>
                  <div className="oldphoto">
                    <img src={this.state.promoImg.url} alt="banner" />
                  </div>
                  <BtnEdit href="/admin/productpromo" />
                </form>
              </div>
              <div className="info">
                <BaseTable
                  columns={this.state.columns}
                  datas={this.props.brands ? this.props.brands : []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, brand }) => {
  return {
    user: auth.user,
    brands: brand.brands,
    promoImg: brand.promoBrand[0] || "",
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  brandFetch,
  brandDeleteById,
  brandFetchPromo,
})(AdminProduct);
